/* eslint-disable @typescript-eslint/naming-convention */
import { ComputationType, HierarchyLevelV2 } from '@twaice-fe/shared/models';
import { Sensor, SensorRequest, SensorResponse } from './data-explorer-types';
import { generateSensorKey } from '../sensor-key-creator';

export function mapToSensor(sensorResponse: SensorResponse): Sensor {
  return {
    levelBk: sensorResponse.level_bk as HierarchyLevelV2,
    sensorType: sensorResponse.sensor_type,
    sensorSubtype: sensorResponse.sensor_subtype,
    aggregationType: sensorResponse.aggregation_type,
    aggregationLevel: sensorResponse.aggregation_level,
    computationType: sensorResponse.computation_type as ComputationType,
    valueType: sensorResponse.value_type,
    unit: sensorResponse.unit,
    name: sensorResponse.name,
    standardSensorBk: sensorResponse.standard_sensor_bk,
    key: generateSensorKey(sensorResponse.name, sensorResponse.level_bk as HierarchyLevelV2, sensorResponse.computation_type),
    scalingFactor: sensorResponse.scaling_factor || 1,
  };
}

export function mapToSensorRequest(sensor: Sensor): SensorRequest {
  return {
    level_bk: sensor.levelBk,
    sensor_type: sensor.sensorType,
    sensor_subtype: sensor.sensorSubtype,
    aggregation_type: sensor.aggregationType,
    aggregation_level: sensor.aggregationLevel,
    computation_type: sensor.computationType,
    value_type: sensor.valueType,
    unit: sensor.unit,
    name: sensor.name,
    standard_sensor_bk: sensor.standardSensorBk,
    scaling_factor: sensor.scalingFactor,
  };
}
